import { render, staticRenderFns } from "./RflmCounterApp.vue?vue&type=template&id=8cb752f0"
import script from "./RflmCounterApp.vue?vue&type=script&lang=ts"
export * from "./RflmCounterApp.vue?vue&type=script&lang=ts"
import style0 from "./RflmCounterApp.vue?vue&type=style&index=0&id=8cb752f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports